import { useContext, useCallback } from "react";

import { VendedoresContext } from "../contexts/VendedoresContext";

import { useHistory } from "react-router";

import { findVendedorByCpfCnpj } from "../../../../repositories/qerpapi/erp/vendas/v1/VendedoresRepository";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import { notify } from "../../../../utils/notify";
import MaskService from "../../../../utils/mask/maskService";
import {
  findByCEP,
  findByCNPJ,
  findByCPF,
} from "../../../../repository/services/BigDataService";
import {
  createVendedor,
  deleteVendedor,
  updateVendedor,
} from "../../../../repository/ERP/vendas/VendedorService";
import Swal from "sweetalert2";
import { validNotNull } from "../../../../utils/validations";

export default function useVendedoresTelaController() {
  let temporizer = null;
  const {
    //Funções
    setExpanded,
    setLoading,
    geralCpfcnpj,
    setGeralCpfCnpj,
    geralRazao,
    setGeralRazao,
    geralFantasia,
    setGeralFantasia,
    geralCep,
    setGeralCEP,
    geralEndereco,
    setGeralEndereco,
    geralNumero,
    setGeralNumero,
    geralComplemento,
    setGeralComplemento,
    geralBairro,
    setGeralBairro,
    geralEstado,
    setGeralEstado,
    geralMunicipio,
    setGeralMunicipio,
    geralPais,
    setGeralPais,
    geralTel1,
    setGeralTel1,
    geralTel2,
    setGeralTel2,
    geralTel3,
    setGeralTel3,
    geralEmail,
    setGeralEmail,
    geralComissaoVenda,
    setGeralComissaoVenda,
    geralTipoVendedor,
    setGeralTipoVendedor,
    geralRegiaoComercial,
    setGeralRegiaoComercial,
    geralEmpresa,
    setGeralEmpresa,
    geralCarteiraPropria,
    setGeralCarteiraPropria,
    geralAtivo,
    setGeralAtivo,
    listUf,
    listCounty,
    bank,
    setBank,
    setGeralErrors,
    dataSellerEdit,
    geralComission,
  } = useContext(VendedoresContext);

  const optionsSetters = {
    general: {
      setCpfCnpj: setGeralCpfCnpj,
      setName: setGeralRazao,
      setFantasy: setGeralFantasia,
      setCep: setGeralCEP,
      setAddress: setGeralEndereco,
      setNumber: setGeralNumero,
      setComplement: setGeralComplemento,
      setDistrict: setGeralBairro,
      setUf: setGeralEstado,
      setCounty: setGeralMunicipio,
      setGeralPais: setGeralPais,
      setGeralTel1: setGeralTel1,
      setGeralTel2: setGeralTel2,
      setGeralTel3: setGeralTel3,
      setEmail: setGeralEmail,
      setGeralComissaoVenda: setGeralComissaoVenda,
      setGeralTipoVendedor: setGeralTipoVendedor,
      setGeralRegiaoComercial: setGeralRegiaoComercial,
      setGeralEmpresa: setGeralEmpresa,
      setGeralCarteiraPropria: setGeralCarteiraPropria,
      setGeralAtivo: setGeralAtivo,
      setBank: setBank,
    },
  };

  const { push } = useHistory();

  const { queryParams } = useContext(QueryParamsContext);

  const handleChangeOpenAccordion = (accordion) => {
    setExpanded((current) => ({
      ...current,
      [accordion]: !current[accordion],
    }));
  };

  const handleNumInscricao = (inputValue) => {
    const verifyCpf = async () => {
      try {
        setLoading(true);
        const sellerExists = await findVendedorByCpfCnpj(
          queryParams.empresa_cnpj,
          inputValue.replace(/[^0-9]+/g, "")
        );
        if (
          sellerExists.success &&
          sellerExists.data.length &&
          sellerExists.data[0].id !== dataSellerEdit.id
        ) {
          setGeralCpfCnpj("");
          setLoading(false);
          return notify("Já existe um Vendedor com este Nº de inscrição.");
        }
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };

    const getData = async () => {
      try {
        setLoading(true);

        const sellerExists = await findVendedorByCpfCnpj(
          queryParams.empresa_cnpj,
          inputValue.replace(/[^0-9]+/g, "")
        );
        if (
          sellerExists.success &&
          sellerExists.data.length &&
          sellerExists.data[0].id !== dataSellerEdit.id
        ) {
          setGeralCpfCnpj("");
          setLoading(false);
          return notify("Já existe um Vendedor com este Nº de inscrição.");
        }

        const response =
          inputValue.length > 14
            ? await findByCNPJ(inputValue.replace(/[^0-9]+/g, ""))
            : await findByCPF(inputValue.replace(/[^0-9]+/g, ""));

        const responseData = response?.data;

        if (
          response.success &&
          responseData.statusCode === 200 &&
          responseData.data
        ) {
          setGeralRazao(
            (responseData.data.corporate_name || "").substring(0, 50)
          );

          handleChangeCep(
            { target: { value: responseData.data.addresses[0]?.postalCode } },
            "general"
          );
          setGeralEndereco(responseData.data.addresses[0]?.street);
          setGeralBairro(responseData.data.addresses[0]?.bairro);
          setGeralComplemento(responseData.data.addresses[0]?.additionalInfo);
          setGeralFantasia(
            (
              responseData.data?.commercial_name ||
              responseData.data?.corporate_name ||
              ""
            ).substring(0, 20)
          );
          setGeralNumero(responseData.data.addresses[0]?.number);
          setGeralTel1(responseData.data.phones[0]?.number);
          setGeralTel2("");
          setGeralTel3("");
          setGeralEmail(responseData.data.emails[0]?.email);
          setGeralEstado(
            listUf.find(
              (opt) => opt.estado === responseData.data.addresses[0].stateCode
            ) || null
          );

          const endereco = await findByCEP(
            responseData.data.addresses[0].postalCode
          );
          const enderecoData = endereco?.data;

          if (endereco.success && enderecoData.statusCode === 200) {
            setGeralMunicipio(
              listCounty.find(
                (opt) => opt.codigo === enderecoData.data.ibgeCode
              ) || null
            );
          } else {
            setGeralMunicipio(null);
          }
          return notify("Preenchimento automático realizado.", true, "success");
        }
        notify(
          "Não foi possível realizar o autopreenchimento, certifique-se de que o N° de Inscrição é válido."
        );
      } catch (error) {
        notify(
          "Não foi possível realizar o autopreenchimento, certifique-se de que o N° de Inscrição é válido."
        );
      } finally {
        setLoading(false);
      }
    };

    if (inputValue.length === 18) {
      getData();
    } else if (inputValue.length === 14) {
      verifyCpf();
    }
  };

  const handleChangeCep = (e, context, settersProp) => {
    const setters = settersProp || optionsSetters[context];

    setters.setCep(MaskService.toMask("cep", e.target.value));

    if (e.target.value.length === 10)
      handleFindByCepHub(e.target.value, context, settersProp);
  };

  const handleFindByCepHub = async (cep, context, settersProp) => {
    try {
      setLoading(true);
      const setters = settersProp || optionsSetters[context];

      const response = await findByCEP(cep);
      const responseData = response?.data;

      if (
        response.success &&
        responseData.statusCode === 200 &&
        responseData.data
      ) {
        setters.setUf(
          (current) =>
            listUf.find((opt) => opt.estado === responseData.data.stateCode) ||
            current
        );
        setters.setAddress((current) => responseData.data.street || current);
        setters.setDistrict(
          (current) => responseData.data.neighborhood || current
        );
        setters.setComplement(
          (current) => responseData.data.additionalInfo || current
        );
        setters.setCounty(
          (current) =>
            listCounty.find(
              (opt) => opt.codigo === responseData.data.ibgeCode
            ) || current
        );
        return;
      }

      notify("CEP não encontrado.");
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCidade = useCallback(
    (prop) => {
      setGeralMunicipio(prop);
    },
    [setGeralMunicipio]
  );

  const handleChangeOpenAcordion = (accordion) => {
    setExpanded((current) => ({
      ...current,
      [accordion]: !current[accordion],
    }));
  };

  const deleteSellerHandler = async (id, setLoading = () => {}) => {
    try {
      const callback = await deleteVendedor(id, queryParams.empresa_cnpj);

      if (callback && callback.success) {
        notify("Vendedor excluído com sucesso!", true, "success");
      } else {
        notify("Ocorreu um erro ao excluir o vendedor.");
      }

      return callback;
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteSeller = (
    id,
    setViewLoading = () => {},
    setReload = () => {}
  ) => {
    Swal.fire({
      icon: "question",
      text: "Tem certeza que deseja excluir o vendedor?",
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: "Não",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        const callback = await deleteSellerHandler(id, setViewLoading);

        if (!callback?.success) return;

        setLoading(false);
        setReload((old) => !old);
      }
    });
  };

  const handleSubmit = async (location) => {
    const requiredFields = [
      { value: geralCpfcnpj, key: "geralCpfcnpj" },
      { value: geralRazao, key: "geralRazao" },
      { value: geralFantasia, key: "geralFantasia" },
      { value: geralEndereco, key: "geralEndereco" },
      { value: geralBairro, key: "geralBairro" },
      { value: geralEstado, key: "geralEstado" },
      { value: geralMunicipio, key: "geralMunicipio" },
      { value: geralComissaoVenda, key: "geralComissaoVenda" },
    ];

    const resultValidation = validNotNull(requiredFields);

    if (geralComissaoVenda > 100) {
      resultValidation.errorsValidation.geralComissaoVenda =
        "Vendedor não pode ter comissão maior que 100%";
      resultValidation.error = true;
    }

    if (resultValidation.error) {
      return setGeralErrors(resultValidation.errorsValidation);
    } else {
      setGeralErrors(false);
    }

    const sellerExists = await findVendedorByCpfCnpj(
      queryParams.empresa_cnpj,
      geralCpfcnpj.replace(/[^0-9]+/g, "")
    );
    if (
      sellerExists.success &&
      sellerExists.data.length &&
      sellerExists.data[0].id !== dataSellerEdit.id
    ) {
      setGeralCpfCnpj("");
      setLoading(false);
      return notify("Já existe um Vendedor com este Nº de inscrição.");
    }

    setLoading(true);
    const submitDataGeral = {
      vendedor: {
        cpfcnpj: geralCpfcnpj.replace(/[^0-9]+/g, ""),
        nomevendedor: (geralRazao ?? "").substring(0, 50),
        apelido: (geralFantasia ?? "").substring(0, 20),
        cep: geralCep.replace(/[^0-9]+/g, ""),
        endereco: geralEndereco,
        numero: geralNumero,
        complemento: geralComplemento,
        bairro: geralBairro,
        id_estado: Number(geralEstado.id),
        cidade: geralMunicipio.codigo,
        pais: Number(geralPais.codigo),
        email: geralEmail,
        telefone: geralTel1 ? geralTel1.replace(/[^0-9]+/g, "") : "",
        telefone2: geralTel2 ? geralTel2.replace(/[^0-9]+/g, "") : "",
        telefone3: geralTel3 ? geralTel3.replace(/[^0-9]+/g, "") : "",
        comissao: geralComissaoVenda.replace(",", "."),
        tipo: geralTipoVendedor ? geralTipoVendedor.value : null,
        regiaocomercial: geralRegiaoComercial
          ? Number(geralRegiaoComercial.id)
          : null,
        idempresa: geralEmpresa ? Number(geralEmpresa.id) : null,
        possuicarteira: geralCarteiraPropria ? "S" : "N",
        ativo: geralAtivo ? "S" : "N",
        contasbancarias: bank,
        idtabelacomissao: geralComission ? Number(geralComission.id) : null,
      },
    };

    var returnApi;
    if (!location.location.state)
      returnApi = await createVendedor(
        queryParams.empresa_cnpj,
        submitDataGeral
      );
    else
      returnApi = await updateVendedor(
        dataSellerEdit.id,
        queryParams.empresa_cnpj,
        submitDataGeral
      );

    if (returnApi.success) {
      return notify(
        "Vendedor cadastrado com sucesso!",
        true,
        "success",
        push("listagem?empresa_cnpj=" + queryParams.empresa_cnpj)
      );
    }
    setLoading(false);
  };

  const handleBackSubmit = () => {
    push("listagem?empresa_cnpj=" + queryParams.empresa_cnpj);
  };

  const handleCancelSubmit = () => {
    Swal.fire({
      icon: "question",
      text: "Tem certeza que deseja cancelar?",
      showConfirmButton: true,
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        push("listagem?empresa_cnpj=" + queryParams.empresa_cnpj);
      }
    });
  };

  const handleEditItemTable = (setOpen, setRowEdit, data = {}, index = -1) => {
    setOpen(true);
    setRowEdit({ data, index });
  };

  const handleDeleteSellerBankAccount = async (item) => {
    if (item.conta_padrao) {
      notify(
        "Atribua outra informação financeira como principal antes de excluir"
      );
      return;
    }

    const result = await Swal.fire({
      icon: "question",
      text: "Tem certeza que deseja excluir a informação bancária do vendedor?",
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: "Não",
    });

    if (result.isConfirmed) {
      const newBankAccounts = [...bank].filter(
        (account) => account.id !== item.id
      );
      setBank(newBankAccounts);
    }
  };

  const handleInputUser = (e) => {
    let newInput = e.target.value.replaceAll(/[^0-9]/g, "");
    const mask =
      newInput.length === 14 ? "cnpj" : newInput.length === 11 ? "cpf" : "";
    let updatedInput = newInput;
    if (mask) {
      updatedInput = MaskService.toMask(mask, newInput);
    }
    setGeralCpfCnpj(updatedInput);

    clearTimeout(temporizer);
    temporizer = setTimeout(() => {
      handleNumInscricao(updatedInput);
    }, 1800);
  };

  return {
    handleSubmit,
    handleChangeOpenAccordion,
    handleNumInscricao,
    handleChangeCep,
    handleBackSubmit,
    handleCancelSubmit,
    handleCidade,
    handleChangeOpenAcordion,
    handleEditItemTable,
    handleDeleteSellerBankAccount,
    handleDeleteSeller,
    handleInputUser,
  };
}
